import {
  TUTORING_LEAD_SOURCES,
  TutoringType
} from "@seneca/tutoring-service-consts";

import { pushEnrichedEventToDataLayerWithCleanUp } from "seneca-common/features/analytics";
import { withLogAndSwallowError } from "seneca-common/utils/senecaAnalytics";

import { Form } from "features/parents/claim-tutoring-journey";
import { TutoringFormModalStep } from "features/parents/features/tutoring-form-modal/consts";

export const makeEventName = (event: string) => {
  const eventName = `s/tutoringClaim/${event}`;

  if (eventName.length >= 41) {
    throw new Error("GTM max event name length is 40 characters");
  }

  return eventName;
};

export const analyticsLogUserSubmittedForm =
  withLogAndSwallowError(userSubmittedForm);

function userSubmittedForm({
  yearGroup,
  subject,
  source,
  form
}: {
  yearGroup?: number;
  subject?: string;
  source: TUTORING_LEAD_SOURCES;
  form: Form;
}) {
  const eventName =
    form === Form.LeadDetails ? "submitted-form" : "submitted-modal-form";

  pushEnrichedEventToDataLayerWithCleanUp({
    event: makeEventName(eventName),
    payload: {
      yearGroup: yearGroup?.toString(),
      subject,
      source
    }
  });
}

export const analyticsLogUserStartedClaimTutoringJourney =
  withLogAndSwallowError(userStartedClaimTutoringJourney);

function userStartedClaimTutoringJourney(source: TUTORING_LEAD_SOURCES) {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: makeEventName("start"),
    payload: {
      source
    }
  });
}

export function analyticsLogClaimTutoringAdModalAction({
  action,
  source
}: {
  action: "Dismiss" | "ClaimTrial";
  source: TUTORING_LEAD_SOURCES;
}) {
  let eventName = `adModal${action}`;

  pushEnrichedEventToDataLayerWithCleanUp({
    event: makeEventName(eventName),
    payload: { source }
  });
}

export function analyticsLogClaimTutoringModalFormEvent({
  action,
  formStep,
  yearGroup,
  subject,
  source,
  tutoringType
}: {
  action: "View" | "CompleteStep" | "Close";
  formStep: TutoringFormModalStep;
  yearGroup?: number;
  subject?: string;
  source: TUTORING_LEAD_SOURCES;
  tutoringType?: TutoringType;
}) {
  let eventName = `modalForm${action}`;

  pushEnrichedEventToDataLayerWithCleanUp({
    event: makeEventName(eventName),
    payload: {
      formStep,
      yearGroup: yearGroup?.toString(),
      subject,
      source,
      tutoringType
    }
  });
}
